// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"541":"sidebar","562":"accounts","768":"page","809":"account"}[chunkId] || chunkId) + "." + {"541":"b46833d3","562":"9b07c16d","673":"442a91e4","768":"201553d1","809":"2c03a404","811":"19ce052b"}[chunkId] + ".chunk.js";
};